export type SortOption = 'date' | 'dateAsc' | 'name' | 'nameDesc';

export const SORT_LABEL: Record<SortOption, string> = {
  date: 'Newest first',
  dateAsc: 'Oldest first',
  name: 'Name (A-Z)',
  nameDesc: 'Name (Z-A)',
};

export const SORT_OPTIONS = Object.keys(SORT_LABEL) as SortOption[];

export type TypeFilter = 'all' | 'single' | 'multistep';

export const TYPE_TABS: { value: TypeFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'single', label: 'Single Page' },
  { value: 'multistep', label: 'Multi-Step' },
];

export const NARROW_ROW_WIDTH = 640;
